import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import qs from 'query-string'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import {
    clearExpireTime,
    closeNotiDoneOrder,
    getOrderInfo,
} from '../actions/orderActions'
import audioBeep from '../assets/audio/beep.wav'
// import { isAppleDevice } from '../utils'
import { getBodyScrollTop } from '../utils/helper'
import { ACCESS_SERVICES_MAP, ORDER_METHOD } from '../constants'
import paths from '../routes/paths'
import { getRestaurantId } from '../selectors'
import { initSocket, setOnReceiveMessage } from '../services/socketService'

const useOrderStatus = (paramName, audioRef) => {
    const [statusInfo, setStatusInfo] = useState()
    const [orderInfo, setOrderInfo] = useState()
    const history = useHistory()
    const location = history.location
    const refSoundEffect = useRef(new Audio())
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const restaurantId = useSelector(getRestaurantId)
    const { firebaseUrl } = useSelector(state => state.RestaurantReducer) || {}

    const stopBeep = () => {
        refSoundEffect.current.pause()
        document.removeEventListener('click', stopBeep)
        const params = qs.parse(location.pathname)
        !!params[paramName] &&
            dispatch(
                closeNotiDoneOrder({
                    params: { orderID: !!params[paramName] },
                })
            )
    }

    const removeOrder = () => {
        const params = qs.parse(location.search)
        delete params[paramName]
        history.replace({
            pathname: location.pathname,
            search: qs.stringify(params),
        })
    }

    const orderExpired = () => {
        history.push({
            pathname: paths.notFound,
            state: {
                message: t('apiMessage.orderExpired'),
            },
        });
    }

    const checkOrderStateValid = state => {
        return [-3, -2, -1, 0, 1, 2].includes(state);
    }

    const orderInvalid = () => {
        history.push({
            pathname: paths.notFound,
            state: {
                message: t('apiMessage.orderInvalid'),
            },
        });
    }

    const handleGetOrderInfo = orderID => {
        // disable browser back button
        window.history.pushState(null, document.title, location.href)
        window.addEventListener('popstate', function (event) {
            console.log('popstate')
            window.history.pushState(null, document.title, location.href)
        })

        dispatch(
            getOrderInfo({
                params: { orderID },
                onDone: data => {
                    if (data.success) {
                        getBodyScrollTop().style.overflow = 'hidden'
                        setOrderInfo(data.responseData)
                        // data.responseData.data.state === 2 && removeOrder()
                        if (!checkOrderStateValid(data.responseData.data.state)) {
                            return orderInvalid();
                        }
                        data.responseData.data.state === -3 && orderExpired()
                    } else {
                        setOrderInfo(false)
                        if (
                            ![
                                ACCESS_SERVICES_MAP[ORDER_METHOD.PICKUP],
                                ACCESS_SERVICES_MAP[ORDER_METHOD.DELIVERY],
                            ].includes(data.responseData.code)
                        ) {
                            orderInvalid();
                        } else {
                            history.replace(location.pathname)
                        }
                    }
                },
            })
        )
    }

    const handleOrderStatusChange = (newStatus, data, orderID) => {
        console.log(newStatus, data);
        if (!checkOrderStateValid(newStatus)) {
            return orderInvalid();
        }

        if (newStatus === -3) {
            return orderExpired();
        }

        if (newStatus === 1) {
            handleGetOrderInfo(orderID)
        }

        setStatusInfo({
            ...(data || {}),
            fromFirebase: true,
        })

        if (newStatus === 2) {
            // removeOrder()

            try {
                if (refSoundEffect.current.src) {
                    refSoundEffect.current.loop = true
                    refSoundEffect.current.play()
                    document.addEventListener('click', stopBeep)
                }
            } catch (_) {}
        }
    }

    const listenFirebase = orderID => {
        const source = new EventSource(
            `${firebaseUrl + restaurantId}_${orderID}.json`
        )

        source.addEventListener('put', e => {
            const data = JSON.parse(e.data)
            if (data?.data) {
                handleOrderStatusChange(data?.data?.status, data?.data);
                source.close()
            }
        })

        const checkOnline = () => {
            window.removeEventListener('online', checkOnline)
            handleListenStatusChange(orderID)
        }

        window.addEventListener('online', checkOnline)
    }

    const listenSocket = async orderID => {
        const socket = await initSocket();
        const clientInfo = {
            cmd: "CLIENT_INFO",
            platform: 0,
            data: {
                orderCode: `${restaurantId}_${orderID}`
            },
            clientVersion: "1.0",
            lang: "vi"
        };
         const params = qs.parse(location.search)
        const orderIDParams = params[paramName]
        socket.sendMessage(clientInfo);
        setOnReceiveMessage((data) => {
            if (data?.cmd === "SYSTEM_NOTIFY_ORDER_STATUS") {
                console.log(data);
                handleOrderStatusChange(data?.data?.status, data?.data, orderIDParams);
            }
        });
    }

    const handleListenStatusChange = orderID => {
        // listenFirebase(orderID);
        listenSocket(orderID);
    }

    useEffect(() => {
        const initAudio = () => {
            try {
                refSoundEffect.current.play().catch(e => {
                    console.log({ e });
                });
                refSoundEffect.current.src = audioBeep;
            } catch (error) {
                console.log({ error });
            }
            document.removeEventListener('click', initAudio)
        }

        document.addEventListener('click', initAudio)

        return () => {
            document.removeEventListener('click', initAudio)
        }
    }, [])

    useEffect(() => {
        const params = qs.parse(location.search)
        const orderID = params[paramName]
        if (history.action === 'REPLACE' && !!orderID) {
            // alert('trigger alter to show menubar')
            dispatch(clearExpireTime())
            handleGetOrderInfo(orderID)
            // handleListenStatusChange(orderID)
        }

        const handleReActiveFromBg = () => {
            if (
                !!orderID &&
                'visible' === document.visibilityState
                // && isAppleDevice()
            ) {
                handleGetOrderInfo(orderID);
            }
        }
        document.addEventListener('visibilitychange', handleReActiveFromBg)

        return () => {
            document.removeEventListener(
                'visibilitychange',
                handleReActiveFromBg
            )
        }
    }, [location])

    // useEffect(() => {
    //     // xử lý khi reload
    //     const params = qs.parse(location.search)
    //     const orderID = params[paramName]
    //     if (!!orderID && !!firebaseUrl) {
    //         handleGetOrderInfo(orderID)
    //         handleListenStatusChange(orderID)
    //     }
    // }, [firebaseUrl])
    useEffect(() => {
        const params = qs.parse(location.search)
        const orderID = params[paramName]
        if (!!orderID) {
            handleGetOrderInfo(orderID)
            // handleListenStatusChange(orderID)
        }
    }, [])

    useEffect(() => {
        if (orderInfo?.data?.id) {
            handleListenStatusChange(orderInfo?.data?.id);
        }
    }, [ orderInfo?.data?.id ]);

    return [statusInfo, orderInfo]
}

export default useOrderStatus
